import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
export const HoverRevealStack = ({ children, }) => {
    return _jsx("div", { className: "hover-reveal-container is-relative", children: children });
};
HoverRevealStack.Item = ({ forceVisible, style, left, top, right, bottom, children, }) => {
    return (_jsx("div", { className: toClassName('item is-flex is-absolute is-inset-0', forceVisible && 'is-visible', left && 'is-justify-content-flex-start', top && 'is-align-items-flex-start', right && 'is-justify-content-flex-end', bottom && 'is-align-items-flex-end'), style: style, children: children }));
};
HoverRevealStack.Item.displayName = 'HoverRevealStack.Item';
//# sourceMappingURL=HoverRevealStack.js.map